import React, { Component } from "react";
import messages from "./ProfileForm.messages";
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel,
  Modal,
} from "react-bootstrap";
import moment from "moment";
import "../forms.css";

import type { UpdateUserObject } from "../../../redux/user/types";
import User from "../../../models/User";
import GradientButton from "../../../components/input/GradientButton";

type Props = {
  updateUser: (params: UpdateUserObject) => Promise<void>,
  onDidUpdate: () => void,
  onModalClose: () => void,
  user: User,
};

type State = {
  firstName: string,
  lastName: string,
  company: string,
  timezone: string,
  photoURI: string,
};

export default class ProfileForm extends Component {
  props: Props;

  state: State = {
    firstName: this.props.user.firstName,
    lastName: this.props.user.lastName,
    company: this.props.user.name ? this.props.user.name : "",
    timezone: this.props.user.timezone ? this.props.user.timezone : "",
    photoURI: this.props.user.avatarURL,
  };

  updateUserPromise: ?Promise<void>;

  handleFirstNameChange = (event) => {
    this.setState({ firstName: event.target.value });
  };

  handleLastNameChange = (event) => {
    this.setState({ lastName: event.target.value });
  };

  handleCompanyChange = (event) => {
    this.setState({ company: event.target.value });
  };

  handleTimezoneChange = (event) => {
    this.setState({ timezone: event.target.value });
  };

  handlePhotoChange = (event) => {
    this.setState({ photoURI: event.target.files[0] });
  };

  handleUpdateUser = (event) => {
    event.preventDefault();
    this.updateUserPromise = Promise.resolve(this.updateUser());
  };

  async updateUser() {
    const _user = await this.props.updateUser({
      name: this.state.company,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      timezone: this.state.timezone,
      avatarURI: this.state.photoURI ? this.state.photoURI : "",
      avatarURL: this.props.user.avatarURL,
      isPremium: this.props.user.isPremium,
      notificationsEnabled: this.props.user.notificationsEnabled,
    });
    this.props.onDidUpdate();
  }

  render() {
    return (
      <div>
        <form onSubmit={this.handleUpdateUser}>
          <Modal.Body>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>{messages.firstName}</ControlLabel>
                  <FormControl
                    type="text"
                    name={messages.firstName}
                    placeholder={messages.firstName}
                    value={this.state.firstName}
                    onChange={this.handleFirstNameChange}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>{messages.lastName}</ControlLabel>
                  <FormControl
                    type="text"
                    name={messages.lastName}
                    placeholder={messages.lastName}
                    value={this.state.lastName}
                    onChange={this.handleLastNameChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>{messages.companyName}</ControlLabel>
                  <FormControl
                    type="text"
                    name={messages.companyName}
                    placeholder={messages.companyName}
                    value={this.state.company}
                    onChange={this.handleCompanyChange}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>{messages.timezone}</ControlLabel>
                  <FormControl
                    componentClass="select"
                    name={messages.timezone}
                    placeholder={messages.timezone}
                    value={this.state.timezone}
                    onChange={this.handleTimezoneChange}
                  >
                    {moment.tz.names().map((value) => (
                      <option value={value} key={value}>
                        {value}
                      </option>
                    ))}
                  </FormControl>
                  {this.props.user.timezone !== moment.tz.guess() && (
                    <ControlLabel
                      style={{ color: "red" }}
                    >{`Suggested: ${moment.tz.guess()}`}</ControlLabel>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>{messages.photo}</ControlLabel>
                  <br />
                  <FormControl
                    type="file"
                    accept="image/*"
                    name={messages.photo}
                    placeholder={messages.photo}
                    onChange={this.handlePhotoChange}
                  ></FormControl>
                </FormGroup>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <GradientButton
              gradient="0/1"
              handleClick={this.props.onModalClose}
              title="Cancel"
            />
            <button type="submit" style={{ padding: 0, border: "none" }}>
              <GradientButton
                gradient="1/1"
                handleClick={this.handleUpdateUser}
                title="Update"
              />
            </button>
          </Modal.Footer>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/profile-form/ProfileForm.js